import { api } from './api';

export interface SearchResult {
  chunkId: string;
  documentId: string;
  documentTitle: string;
  sourceKind: string;
  sourceUrl: string | null;
  page: number | null;
  headingPath: string[];
  snippet: string;
  score: number;
  lanes: ('dense' | 'lexical' | 'graph')[];
}

export interface SearchResponse {
  query: string;
  results: SearchResult[];
}

export const searchApi = {
  async search(workspaceId: string, query: string, topK = 10): Promise<SearchResponse> {
    const r = await api.post<SearchResponse>(`/api/workspaces/${workspaceId}/search`, { query, topK });
    return r.data;
  },
};
